export function storeEventName(eventName) {
  return sessionStorage.setItem("eventName",eventName);
}

export function removeEventName() {
  return sessionStorage.removeItem("eventName");
}